import { useUserLocation } from '~/context/common/UserContext';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';

const temporaryOutOfMarketZips = [
  89421, 97010, 97134, 97143, 97406, 97407, 97411, 97414, 97415, 97420, 97423,
  97427, 97444, 97450, 97458, 97459, 97464, 97465, 97466, 97476, 97484, 97491,
  97497, 97501, 97502, 97503, 97504, 97520, 97522, 97523, 97524, 97525, 97526,
  97527, 97528, 97530, 97531, 97532, 97533, 97534, 97535, 97536, 97537, 97538,
  97539, 97540, 97541, 97543, 97544, 97601, 97602, 97603, 97604, 97620, 97621,
  97622, 97623, 97624, 97625, 97626, 97627, 97630, 97632, 97633, 97634, 97635,
  97636, 97637, 97638, 97639, 97640, 97641, 97709, 97710, 97720, 97721, 97722,
  97731, 97732, 97735, 97736, 97738, 97751, 97752, 97758, 97814, 97817, 97819,
  97820, 97824, 97825, 97827, 97828, 97833, 97834, 97837, 97840, 97841, 97842,
  97845, 97846, 97850, 97856, 97857, 97865, 97867, 97869, 97870, 97873, 97876,
  97877, 97883, 97884, 97885, 97901, 97902, 97903, 97904, 97905, 97906, 97907,
  97908, 97909, 97910, 97911, 97913, 97914, 97917, 97918, 97920
];

export default function useIsTemporaryOutOfMarket() {
  const { outOfMarket } = useAlertStatus();
  const { zip } = useUserLocation();

  return outOfMarket && temporaryOutOfMarketZips.includes(Number(zip));
}
